module.exports = __webpack_public_path__ + "img/news_01.e32bd8a1.jpg";